"use client";
import { createContext, useContext, useSyncExternalStore } from "react";
const TouchPointerOverrideContext = createContext(void 0);
const ShouldUseDrawerOverrideProvider = TouchPointerOverrideContext.Provider;
const POINTER_QUERY = '(pointer: coarse)';
const VIEWPORT_QUERY = '(max-width: 767px)';
function makeSubscribe(query) {
    return (callback)=>{
        if (void 0 === globalThis.window) return ()=>{};
        const mql = globalThis.window.matchMedia(query);
        mql.addEventListener('change', callback);
        return ()=>mql.removeEventListener('change', callback);
    };
}
function makeSnapshot(query) {
    return ()=>globalThis.window?.matchMedia(query).matches ?? false;
}
const subscribePointer = makeSubscribe(POINTER_QUERY);
const getPointerSnapshot = makeSnapshot(POINTER_QUERY);
const subscribeViewport = makeSubscribe(VIEWPORT_QUERY);
const getViewportSnapshot = makeSnapshot(VIEWPORT_QUERY);
const getServerSnapshot = ()=>false;
function useShouldUseDrawer() {
    const pointerOverride = useContext(TouchPointerOverrideContext);
    const realPointer = useSyncExternalStore(subscribePointer, getPointerSnapshot, getServerSnapshot);
    const realViewport = useSyncExternalStore(subscribeViewport, getViewportSnapshot, getServerSnapshot);
    const pointerLeg = pointerOverride ?? realPointer;
    return pointerLeg && realViewport;
}
function useIsBelowMdViewport() {
    return useSyncExternalStore(subscribeViewport, getViewportSnapshot, getServerSnapshot);
}
function useIsTouchPointer() {
    const pointerOverride = useContext(TouchPointerOverrideContext);
    const realPointer = useSyncExternalStore(subscribePointer, getPointerSnapshot, getServerSnapshot);
    return pointerOverride ?? realPointer;
}
export { ShouldUseDrawerOverrideProvider, useIsBelowMdViewport, useIsTouchPointer, useShouldUseDrawer };
